import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Shield } from 'lucide-react';

export function Datenschutz() {
  return (
    <div className="min-h-screen bg-background py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <Link
          to="/login"
          className="inline-flex items-center text-sm text-muted-foreground hover:text-foreground mb-8 transition-colors"
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Zurück zur Anmeldung
        </Link>

        <div className="bg-card rounded-lg shadow-sm border border-border p-8">
          <div className="flex items-center mb-8">
            <Shield className="h-8 w-8 text-primary mr-3" />
            <h1 className="text-3xl font-bold text-foreground">Datenschutzerklärung</h1>
          </div>

          <div className="space-y-8 text-foreground">

            {/* ===== 1. DATENSCHUTZ AUF EINEN BLICK ===== */}
            <section>
              <h2 className="text-xl font-semibold mb-4">1. Datenschutz auf einen Blick</h2>

              <h3 className="font-semibold text-base mb-2">Allgemeine Hinweise</h3>
              <p className="text-muted-foreground leading-relaxed mb-4">
                Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen
                Daten passiert, wenn Sie unsere Anwendung nutzen. Personenbezogene Daten sind alle Daten, mit
                denen Sie persönlich identifiziert werden können. Ausführliche Informationen zum Thema Datenschutz
                entnehmen Sie unserer unter diesem Text aufgeführten Datenschutzerklärung.
              </p>

              <h3 className="font-semibold text-base mb-2">Datenerfassung in dieser Anwendung</h3>
              <p className="text-muted-foreground leading-relaxed">
                Die Datenverarbeitung in dieser Anwendung erfolgt durch den Betreiber. Dessen Kontaktdaten
                können Sie dem Abschnitt „Verantwortliche Stelle" entnehmen. Daten werden zum einen dadurch
                erhoben, dass Sie uns diese mitteilen (z.&nbsp;B. Registrierung), zum anderen automatisch durch
                unsere IT-Systeme (z.&nbsp;B. IP-Adresse beim Zugriff).
              </p>
            </section>

            {/* ===== 2. VERANTWORTLICHE STELLE ===== */}
            <section className="pt-6 border-t border-border">
              <h2 className="text-xl font-semibold mb-4">2. Verantwortliche Stelle</h2>
              <p className="text-muted-foreground leading-relaxed mb-4 text-sm">
                Die verantwortliche Stelle für die Datenverarbeitung ist:
              </p>
              <div className="bg-muted rounded-lg p-4">
                <p className="font-semibold text-foreground">AllFlowX Ali Tombul</p>
                <p className="text-muted-foreground">Karl-Joos-Straße 8</p>
                <p className="text-muted-foreground">70806 Kornwestheim</p>
                <p className="text-muted-foreground mt-2">
                  E-Mail:{' '}
                  <a href="mailto:support@allflowx.de" className="text-primary hover:underline">
                    support@allflowx.de
                  </a>
                </p>
                <p className="text-muted-foreground">
                  Telefon:{' '}
                  <a href="tel:+4917270120556" className="text-primary hover:underline">
                    +49 (0) 172 701 20 56
                  </a>
                </p>
              </div>
              <p className="text-muted-foreground leading-relaxed mt-3 text-sm">
                Verantwortliche Stelle ist die natürliche oder juristische Person, die allein oder gemeinsam mit
                anderen über die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten entscheidet.
              </p>
            </section>

            {/* ===== 3. ALLGEMEINE HINWEISE UND PFLICHTINFORMATIONEN ===== */}
            <section className="pt-6 border-t border-border">
              <h2 className="text-xl font-semibold mb-4">3. Allgemeine Hinweise und Pflichtinformationen</h2>

              <h3 className="font-semibold text-base mb-2">SSL- bzw. TLS-Verschlüsselung</h3>
              <p className="text-muted-foreground leading-relaxed mb-5 text-sm">
                Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte,
                wie zum Beispiel Bestellungen oder Anfragen, die Sie an uns als Betreiber senden, eine SSL- bzw.
                TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile
                des Browsers von „http://" auf „https://" wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.
              </p>

              <h3 className="font-semibold text-base mb-2">Widerruf Ihrer Einwilligung zur Datenverarbeitung</h3>
              <p className="text-muted-foreground leading-relaxed mb-5 text-sm">
                Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung möglich. Sie
                können eine bereits erteilte Einwilligung jederzeit widerrufen. Die Rechtmäßigkeit der bis zum
                Widerruf erfolgten Datenverarbeitung bleibt vom Widerruf unberührt.
              </p>

              <h3 className="font-semibold text-base mb-2">
                Widerspruchsrecht gegen die Datenerhebung in besonderen Fällen sowie gegen Direktwerbung (Art. 21 DSGVO)
              </h3>
              <div className="bg-muted rounded-lg p-4">
                <p className="text-muted-foreground text-sm leading-relaxed uppercase font-medium">
                  WENN DIE DATENVERARBEITUNG AUF GRUNDLAGE VON ART. 6 ABS. 1 LIT. E ODER F DSGVO ERFOLGT,
                  HABEN SIE JEDERZEIT DAS RECHT, AUS GRÜNDEN, DIE SICH AUS IHRER BESONDEREN SITUATION ERGEBEN,
                  GEGEN DIE VERARBEITUNG IHRER PERSONENBEZOGENEN DATEN WIDERSPRUCH EINZULEGEN.
                </p>
              </div>
            </section>

            {/* ===== 4. HOSTING UND TECHNISCHE INFRASTRUKTUR ===== */}
            <section className="pt-6 border-t border-border">
              <h2 className="text-xl font-semibold mb-4">4. Hosting und technische Infrastruktur</h2>
              <p className="text-muted-foreground text-sm mb-4">
                Wir hosten unsere Anwendung bei folgenden Anbietern:
              </p>

              <div className="space-y-4">
                <div className="bg-muted rounded-lg p-4">
                  <p className="font-semibold text-foreground mb-2">IONOS (Domain, DNS &amp; Firewall)</p>
                  <p className="text-muted-foreground text-sm leading-relaxed">
                    Anbieter ist die IONOS SE, Elgendorfer Str. 57, 56410 Montabaur (im Folgenden: IONOS).
                    Wenn Sie unsere Anwendung aufrufen, erfasst IONOS verschiedene Logfiles inklusive Ihrer
                    IP-Adressen. Details entnehmen Sie der Datenschutzerklärung von IONOS:{' '}
                    <a
                      href="https://www.ionos.de/terms-gtc/terms-privacy"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-primary hover:underline"
                    >
                      ionos.de/terms-gtc/terms-privacy
                    </a>
                    .
                  </p>
                  <p className="text-muted-foreground text-xs mt-2">
                    Rechtsgrundlage: Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;f DSGVO. Wir haben ein berechtigtes
                    Interesse an einer möglichst zuverlässigen Darstellung und Sicherheit unserer Anwendung.
                  </p>
                </div>

                <div className="bg-muted rounded-lg p-4">
                  <p className="font-semibold text-foreground mb-2">Emergent Agent Platform (Anwendungsserver)</p>
                  <p className="text-muted-foreground text-sm leading-relaxed">
                    Die Bereitstellung der Kubernetes-basierten Infrastruktur erfolgt durch Emergent innerhalb
                    der EU.
                  </p>
                </div>

                <div className="bg-muted rounded-lg p-4">
                  <p className="font-semibold text-foreground mb-2">MongoDB Atlas (Datenbank)</p>
                  <p className="text-muted-foreground text-sm leading-relaxed">
                    Anbieter: MongoDB, Inc., USA. Physischer Server-Standort:{' '}
                    <strong className="text-foreground">Frankfurt am Main, Deutschland</strong>. Die Daten
                    verbleiben innerhalb der EU. Es besteht ein AVV gemäß Art.&nbsp;28 DSGVO.
                  </p>
                </div>
              </div>
            </section>

            {/* ===== 5. DATENERFASSUNG UND DIENSTE ===== */}
            <section className="pt-6 border-t border-border">
              <h2 className="text-xl font-semibold mb-4">5. Datenerfassung und Dienste</h2>

              <h3 className="font-semibold text-base mb-3">5.1 Kategorien der verarbeiteten Daten</h3>
              <ul className="list-disc list-inside text-muted-foreground text-sm space-y-2 ml-2 mb-6">
                <li>
                  <strong className="text-foreground">Benutzerdaten:</strong> Name, E-Mail, Telefonnummer,
                  Rolle, verschlüsseltes Passwort.
                </li>
                <li>
                  <strong className="text-foreground">Betriebliche Daten:</strong> Aufgabenprotokolle,
                  Temperaturaufzeichnungen (HACCP), MHD-Kontrollen, Unterweisungen.
                </li>
                <li>
                  <strong className="text-foreground">Lotto-Modul:</strong> Paket- und Seriennummern von
                  Rubellosen zur gesetzlichen Dokumentation (Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;c DSGVO).
                </li>
                <li>
                  <strong className="text-foreground">Referral- &amp; Credit-System:</strong> Verknüpfung
                  von Empfehlungen und Verwaltung von Kundenguthaben.
                </li>
              </ul>

              <h3 className="font-semibold text-base mb-3">5.2 Drittanbieter (Auftragsverarbeitung)</h3>
              <p className="text-muted-foreground text-sm mb-3">
                Mit allen Dienstleistern wurden Verträge zur Auftragsverarbeitung (AVV) gemäß
                Art.&nbsp;28 DSGVO geschlossen:
              </p>
              <div className="space-y-3">
                <div className="bg-muted rounded-lg p-4">
                  <p className="font-semibold text-foreground mb-1">Stripe</p>
                  <p className="text-muted-foreground text-sm">
                    Zahlungsabwicklung &amp; Gutscheine. (Übermittlung in USA erfolgt auf Basis von
                    Standardvertragsklauseln und dem Data Privacy Framework).
                  </p>
                </div>
                <div className="bg-muted rounded-lg p-4">
                  <p className="font-semibold text-foreground mb-1">Brevo</p>
                  <p className="text-muted-foreground text-sm">
                    Versand von System-E-Mails (Serverstandort: Frankreich/EU).
                  </p>
                </div>
              </div>
            </section>

            {/* ===== 6. COOKIES UND LOCAL STORAGE ===== */}
            <section className="pt-6 border-t border-border">
              <h2 className="text-xl font-semibold mb-4">6. Cookies und Local Storage</h2>
              <p className="text-muted-foreground leading-relaxed text-sm">
                Unsere Anwendung verwendet technisch notwendige Elemente (Local Storage/Session Cookies),
                um die Anmeldung eines Nutzers über verschiedene Seiten hinweg aufrechtzuerhalten und
                Sicherheitsfunktionen bereitzustellen.
              </p>
              <p className="text-muted-foreground text-xs mt-3">
                Rechtsgrundlage: § 25 Abs.&nbsp;2 TDDDG (unbedingte Erforderlichkeit zur Bereitstellung
                des Dienstes).
              </p>
            </section>

            {/* ===== 7. DATENSPEICHERUNG UND LÖSCHUNG ===== */}
            <section className="pt-6 border-t border-border">
              <h2 className="text-xl font-semibold mb-4">7. Datenspeicherung und Löschung</h2>
              <div className="space-y-3">
                <div className="flex gap-3 text-sm">
                  <span className="text-primary font-bold flex-shrink-0">30 Tage</span>
                  <p className="text-muted-foreground">
                    <strong className="text-foreground">Account-Löschung:</strong> Personenbezogene Daten
                    werden innerhalb von 30 Tagen nach Löschantrag endgültig gelöscht.
                  </p>
                </div>
                <div className="flex gap-3 text-sm">
                  <span className="text-primary font-bold flex-shrink-0">10 Jahre</span>
                  <p className="text-muted-foreground">
                    <strong className="text-foreground">Gesetzliche Aufbewahrung:</strong> Abrechnungsdaten
                    (Rechnungen, Lotto-Belege) werden gemäß § 147 AO / § 257 HGB für 10 Jahre archiviert.
                  </p>
                </div>
              </div>
            </section>

            {/* ===== 8. IHRE RECHTE ===== */}
            <section className="pt-6 border-t border-border">
              <h2 className="text-xl font-semibold mb-4">8. Ihre Rechte</h2>
              <p className="text-muted-foreground text-sm mb-4">Sie haben das Recht auf:</p>
              <div className="space-y-2">
                {[
                  { art: 'Art. 15', title: 'Auskunft', desc: 'DSGVO' },
                  { art: 'Art. 16', title: 'Berichtigung', desc: 'DSGVO' },
                  { art: 'Art. 17', title: 'Löschung', desc: 'DSGVO' },
                  { art: 'Art. 20', title: 'Datenübertragbarkeit', desc: 'DSGVO' },
                ].map(({ art, title, desc }) => (
                  <div key={art} className="flex gap-3 text-sm">
                    <span className="text-primary font-mono font-semibold flex-shrink-0 w-16">{art}</span>
                    <p className="text-muted-foreground">
                      <strong className="text-foreground">{title}</strong> ({desc})
                    </p>
                  </div>
                ))}
              </div>

              <div className="mt-6 bg-muted rounded-lg p-4">
                <p className="font-semibold text-foreground mb-1">Beschwerderecht bei der Aufsichtsbehörde</p>
                <p className="text-muted-foreground text-sm">
                  Landesbeauftragter für den Datenschutz Baden-Württemberg<br />
                  Lautenschlagerstraße 20, 70173 Stuttgart
                </p>
              </div>
            </section>

          </div>

          <div className="mt-8 pt-6 border-t border-border">
            <p className="text-xs text-muted-foreground">
              Stand: {new Date().toLocaleDateString('de-DE', { month: 'long', year: 'numeric' })}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
